// extracted by mini-css-extract-plugin
export default {"container":"_i-z","bubbleNav":"aj-z","graphic":"bj-z","contact":"cj-z"};